import pipe from './pipe.js';
import { _ as __spreadArrays } from '../_tslib-349981d7.js';
var mayBeEmptyString = function mayBeEmptyString() {
  var validators = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    validators[_i] = arguments[_i];
  }
  return function (value) {
    var fieldValidatorArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      fieldValidatorArgs[_i - 1] = arguments[_i];
    }
    if (!value || value.length === 0) {
      return;
    }
    return pipe.apply(void 0, validators).apply(void 0, __spreadArrays([value], fieldValidatorArgs));
  };
};
export default mayBeEmptyString;
export { mayBeEmptyString };